import { Error } from "../../../shared/Error";

export const NotFound = () => {
  return (
    <Error
      error={{
        title: "Strona nie znaleziona",
        message: "Sprawdź, czy adres jest poprawny",
      }}
    />
  );
};
